const regular: FontType = 'PlusJakartaSans-Regular';
const bold: FontType = 'PlusJakartaSans-Bold';
const boldItalic: FontType = 'PlusJakartaSans-BoldItalic';
const extraBold: FontType = 'PlusJakartaSans-ExtraBold';
const extraBoldItalic: FontType = 'PlusJakartaSans-ExtraBoldItalic';
const extraLight: FontType = 'PlusJakartaSans-ExtraLight';
const extraLightItalic: FontType = 'PlusJakartaSans-ExtraLightItalic';
const italic: FontType = 'PlusJakartaSans-Italic';
const light: FontType = 'PlusJakartaSans-Light';
const lightItalic: FontType = 'PlusJakartaSans-LightItalic';
const medium: FontType = 'PlusJakartaSans-Medium';
const mediumItalic: FontType = 'PlusJakartaSans-MediumItalic';

export type FontType =
  | 'PlusJakartaSans-Regular'
  | 'PlusJakartaSans-Bold'
  | 'PlusJakartaSans-BoldItalic'
  | 'PlusJakartaSans-ExtraBold'
  | 'PlusJakartaSans-ExtraBoldItalic'
  | 'PlusJakartaSans-ExtraLight'
  | 'PlusJakartaSans-ExtraLightItalic'
  | 'PlusJakartaSans-Italic'
  | 'PlusJakartaSans-Light'
  | 'PlusJakartaSans-LightItalic'
  | 'PlusJakartaSans-Medium'
  | 'PlusJakartaSans-MediumItalic';

const FONTS = {
  regular,
  bold,
  boldItalic,
  extraBold,
  extraBoldItalic,
  extraLight,
  extraLightItalic,
  italic,
  light,
  lightItalic,
  medium,
  mediumItalic,
};

export default FONTS;
